let state = {
    getAluno:{},
    get_aluno:{},
    allalunos:[],
    allmatriculaaluno:[],
    allfaturasaluno:[],
    buscar_alunos:[]
    

}

export default state